/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useState } from 'react';
import { Box, Button } from '@mui/material';
import KeycloakUserCreationForm from './keycloakUserCreationForm';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../../components/shared/Dialog/DialogContainer';
import { createMySQLConnectionKeycloak } from '../../../../../../services/keycloak/keycloak';
import { toast } from 'react-toastify';
import { getAllKeyCloakUsers } from '../../../../../../store/reducers/keyCloak/keyCloakAction';
import { useDispatch } from 'react-redux';

const KeycloakDBConnection = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);


    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            await createMySQLConnectionKeycloak(values);
            toast.success('Connection was created successfully');
            await dispatch(getAllKeyCloakUsers({ "realm": "getchkd" })).unwrap();

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right', marginRight: '10px' }} onClick={handleOpen}>Create DB Connection</Button>
            {/* Dialog for Adding User */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Formik
                        initialValues={{
                            realm: 'getchkd',

                            userName: '',
                            connectionName: '',
                            connectionUser: '',
                            connectionPass: '',

                        }}
                        validationSchema={Yup.object().shape({
                            realm: Yup.string().required('Realm is required.'),
                            userName: Yup.string().required('User Name is required.'),
                            connectionName: Yup.string().required('Connection Name is required.'),

                            connectionUser: Yup.string().required('Connection user is required.'),
                            connectionPass: Yup.string().required('Password is required.'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <KeycloakUserCreationForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />)}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default KeycloakDBConnection;
